import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { useState, useEffect } from 'react';
import { navItems, API_KEY} from '../../utils/constants';
import axios from 'axios';
import Stack from '@mui/material/Stack';
import { Skeleton, Tooltip } from '@mui/material';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import IconButton from '@mui/material/IconButton';
import Papa from 'papaparse';
import { Link } from 'react-router-dom';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

function Navbar() {
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [data, setData] = useState([])
    const [fileData, setFileData] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const fetchData = async () => {
          try {
          setIsLoading(true)
          const response = await axios.get(`${API_KEY}/dkContests`)
          setData(response.data)
        }
          catch (error) {
            console.error(error)
          }finally {
            setIsLoading(false)
          }
      }
        fetchData()
      }, [])
      
    const handleOpenUserMenu = (event) => {
      setAnchorElUser(event.currentTarget);
    };
  
    const handleCloseUserMenu = () => {
      setAnchorElUser(null);
    };
  
    const changeHandler = (event) => {
        Papa.parse(event.target.files[0], {
            header: true,
            skipEmptyLines: true,
            complete: function (results) {
                setFileData(results.data)
            },
          });
      };


      async function postData() {
        try{
          console.log('File Data:', fileData)
          await axios.post(`${API_KEY}/uploadPlayerMins`, fileData)
        }
        catch (error) {
          console.error(error)
        }
      }

      async function deleteData() {
        try{
          await axios.delete(`${API_KEY}/clearPlayerMins`)
        }
        catch (error) {
          console.error(error)
        }
      }


 
  
  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' } }}>
            <Button key={navItems[0]} onClick={handleOpenUserMenu} sx={{ my: 2, color: 'white', display: 'block' }}>{navItems[0].name}</Button>
            <Button key={navItems[1]} href={navItems[1].link} sx={{ my: 2, color: 'white', display: 'block' }}>{navItems[1].name}</Button>
            <Button key={navItems[2]} href={navItems[2].link} sx={{ my: 2, color: 'white', display: 'block' }}>{navItems[2].name}</Button>
            <Tooltip title="Upload player minutes. Make sure columns are: Player, ExpectedMins"><IconButton aria-label="upload" component='label' sx={{color:"#ffffff"}}><input type='file' accept='.csv' onChange={changeHandler} hidden/><FileUploadOutlinedIcon/></IconButton></Tooltip>
            {fileData.length > 0 && <Button onClick={postData} variant='text' sx={{color:'white'}}>Upload Mins</Button> }   
            <Tooltip title="Delete all expected player mins. WARNING!"><IconButton aria-label="delete" onClick={deleteData} component='label' sx={{color:"#ffffff"}}><DeleteForeverIcon/></IconButton></Tooltip>          
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
            {isLoading && <Skeleton sx={{mx: 2}}variant="rectangular" width={290} height={40} />}
              {data.map((game, i) => (
                <MenuItem key={i} onClick={handleCloseUserMenu} component={Link} to={`fantasy/${game.DraftGroup}/${game.Type}`}>
                <Stack direction="row" spacing={1} >
                  <Typography textAlign="center">{game.Sport}</Typography>
                  <Typography textAlign="center">{game.Team}</Typography>
                  <Typography textAlign="center">{game.Time}</Typography>
                  <Typography textAlign="center">{game.Type}</Typography>
                </Stack>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Navbar;